import { Store } from 'redux';

import { selectPageModelNetwork } from 'store/pageModel';
import { ErrorTypes, LoadDataReject } from 'types/load-data-reject-reason';
import { fetchCategoriesRequest, selectConfiguratorsNetwork } from 'containers/categories-listing';

export const CategoriesListingPageLoadData = (store: Store) =>
	new Promise<void>((resolve, reject: LoadDataReject) => {
		const pageModelNetwork = selectPageModelNetwork(store.getState());

		if (pageModelNetwork.isFetched && pageModelNetwork.isFailed) {
			return reject({ type: ErrorTypes.PAGE_MODEL, message: 'No page model data' });
		}

		store.dispatch(fetchCategoriesRequest());

		const unsub = store.subscribe(() => {
			const categoriesNetwork = selectConfiguratorsNetwork(store.getState());

			if (categoriesNetwork.isFetched) {
				unsub();
				if (categoriesNetwork.isFailed) {
					return reject({
						type: ErrorTypes.DATA,
						message: 'Categories data was not fetched',
					});
				} else {
					return resolve();
				}
			}
		});
	});
